const LOCKED_CHATS_KEY = "lockedChats";
const PIN_HASH_PREFIX = "chatLockPinHash_";

export const CHAT_LOCK_PIN_LENGTH = 4;

export function hashChatLockPin(pin, userId) {
  const raw = `${userId}:${pin}`;
  let h = 5381;
  for (let i = 0; i < raw.length; i++) {
    h = (h * 33) ^ raw.charCodeAt(i);
  }
  return `v1_${(h >>> 0).toString(36)}`;
}

export function getPinStorageKey(userId) {
  return `${PIN_HASH_PREFIX}${userId}`;
}

export function hasChatLockPin(userId) {
  if (!userId) return false;
  try {
    return Boolean(localStorage.getItem(getPinStorageKey(userId)));
  } catch {
    return false;
  }
}

export function saveChatLockPin(userId, pin) {
  localStorage.setItem(getPinStorageKey(userId), hashChatLockPin(pin, userId));
}

export function verifyChatLockPin(userId, pin) {
  if (!userId || !pin) return false;
  try {
    const stored = localStorage.getItem(getPinStorageKey(userId));
    return stored === hashChatLockPin(pin, userId);
  } catch {
    return false;
  }
}

export function loadLockedChats() {
  try {
    const saved = localStorage.getItem(LOCKED_CHATS_KEY);
    return saved ? JSON.parse(saved) : {};
  } catch {
    return {};
  }
}

export function saveLockedChats(lockedChats) {
  try {
    localStorage.setItem(LOCKED_CHATS_KEY, JSON.stringify(lockedChats));
  } catch (error) {
    console.error("Error saving locked chats:", error);
  }
}

export function isChatLocked(lockedChats, contactId) {
  return Boolean(contactId && lockedChats?.[contactId]);
}
